import { Alert } from '../../alert/alert.model';

/**
 * Interface for the 'Alert' data
 */
export interface AlertEntity extends Alert {
  id: string | string; // Primary ID
}
